import { getThemeColor, Styles } from "@mcleod/core";

export class TableRowStylesUtil {
    public static readonly HOVER_BACKGROUND_CSS =
        `${getThemeColor("table.hoverBackground")} radial-gradient(circle, transparent 1%, ${getThemeColor("table.hoverBackground")} 1%) center/15000%`;
}

export const TableRowStyles = Styles.make("row", () => {
    const result = {
        base: {
            display: "table",
            width: "100%",
            tableLayout: "fixed",
            borderBottom: "1px solid #AAA",
            minHeight: "32px",
            padding: "0px",
            borderSpacing: "0px",
            backgroundPosition: "center",
            transition: "background 300ms",
        },
        hoverShade: {
            "&:hover": {
                background: TableRowStylesUtil.HOVER_BACKGROUND_CSS
            }
        }
    }
    return result;

});
